// eslint-disable-next-line import/prefer-default-export
export const LOGIN_CHANGE = 'LOGIN_CHANGE';
